/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { useAppConfig } from '@airasia-rn/ui';
import { useUser } from './account';

/** Language an OTP email or SMS is sent in when the user has no saved preference. */
export const DEFAULT_CULTURE_CODE = 'en-GB';

/**
 * The culture code to send with an OTP request: the user's saved preference
 * first, then whatever locale the app is running in, then a fixed default.
 *
 * Every OTP request needs this and each one used to inline its own fallback
 * chain, which drifted into three spellings of the default.
 */
export function useCultureCode(caller: string = 'useCultureCode'): string {
  const { data: user } = useUser(caller);
  const appConfig = useAppConfig();

  return user?.cultureCode || appConfig.config.locale || DEFAULT_CULTURE_CODE;
}
